import React from 'react';
import { Link } from 'react-router-dom';
import { products } from '../data/products';
const platformLinks = [{
  to: '/platform',
  label: 'Platform'
}, {
  to: '/brand',
  label: 'Brand Portal'
}, {
  to: '/investor',
  label: 'Investor'
}, {
  to: '/#start',
  label: 'Contact'
}];
export function Footer() {
  return <footer className="bg-ink px-5 py-12 text-paper md:px-10" data-id="element-404" data-mp="36n3d9nedlqua">
      <div className="mx-auto max-w-shell" data-id="element-405" data-mp="3ugbqj7nstejc">
        <div className="grid gap-10 md:grid-cols-[1fr_1fr]" data-id="element-406" data-mp="38qvoyiyxrr6">
          <div data-id="element-407" data-mp="387ejk1577e7">
            <Link to="/" className="font-display text-3xl font-bold" data-id="element-408" data-mp="36mtqm4mr2tj">
              SAMPLER
            </Link>
            <p className="mt-4 max-w-xs text-lg leading-relaxed text-paper/70" data-id="element-409" data-mp="3lgonyijc22op">
              The product experience platform.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8" data-id="element-410" data-mp="29ydvry6nv08u">
            <nav aria-label="Products" data-id="element-411" data-mp="2eya0y0r3gxpz">
              <p className="text-xs font-extrabold tracking-[0.14em] text-paper/45" data-id="element-412" data-mp="2ezbf4e3eq0bx">
                PRODUCTS
              </p>
              <ul className="mt-4 flex flex-col gap-3 text-sm font-bold" data-id="element-413" data-mp="3l9sin4pzgsoh">
                {products.map(product => <li key={product.slug} data-id="element-414" data-mp="3v7q63q00qlg1">
                    <Link to={product.path} className="flex items-center gap-2.5 text-paper/75 hover:text-paper" data-id="element-415" data-mp="3v8rgds97n3wp">
                      <span className={`h-2 w-2 shrink-0 rounded-full ${product.theme.dotOnDark}`} aria-hidden="true" data-id="element-416" data-mp="82icpt2wkaeu" />
                      {product.name}
                    </Link>
                  </li>)}
              </ul>
            </nav>
            <nav aria-label="Company" data-id="element-417" data-mp="cv1qaq1lb5jn">
              <p className="text-xs font-extrabold tracking-[0.14em] text-paper/45" data-id="element-418" data-mp="cw34v4htea64">
                PLATFORM
              </p>
              <ul className="mt-4 flex flex-col gap-3 text-sm font-bold" data-id="element-419" data-mp="msg6qpnijuby">
                {platformLinks.map(link => <li key={link.to} data-id="element-420" data-mp="tw618ehn64qf">
                    <Link to={link.to} className="text-paper/75 hover:text-paper" data-id="element-421" data-mp="tt0ayvxa0wt4">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>
        </div>
        <div className="mt-16 border-t border-paper/15 pt-7 md:flex md:items-end md:justify-between" data-id="element-422" data-mp="1clmcnwuv7hlm">
          <p className="font-display text-2xl font-bold leading-tight md:text-3xl" data-id="element-423" data-mp="1hkp58htnrvcp">
            Advertising interrupts experiences.
            <br data-id="element-424" data-mp="1mktogflyb46m" />
            <span className="text-signal" data-id="element-425" data-mp="1ml3chxnfr19o">We turn brands into them.</span>
          </p>
          <p className="mt-8 text-xs font-bold text-paper/55 md:mt-0" data-id="element-426" data-mp="1rhtvasqmkays">
            © 2026 SAMPLER
          </p>
        </div>
      </div>
    </footer>;
}